import React from 'react';
import { CTA_LABEL, scrollToBuy } from '../utils/constants';
type CtaButtonProps = {
  label?: string;
  className?: string;
  href?: string;
};
const BASE = 'inline-flex w-full max-w-md items-center justify-center rounded-full bg-cta px-5 py-3 text-center font-head text-[15px] font-bold uppercase leading-tight tracking-wide text-night shadow-[0_5px_0_0_#0F7A4E] transition-colors duration-150 ease-out hover:bg-cta-dark active:translate-y-[2px] active:shadow-[0_3px_0_0_#0F7A4E] sm:px-7 sm:py-3.5 sm:text-lg';
export function CtaButton({
  label = CTA_LABEL,
  className = '',
  href
}: CtaButtonProps) {
  if (href) {
    return <a href={href} className={`${BASE} ${className}`} data-id="element-74" data-mp="109tzmbj3sxor">
        {label}
      </a>;
  }
  return <button type="button" onClick={scrollToBuy} className={`${BASE} ${className}`} data-id="element-75" data-mp="vclga7m7ynlx">
      {label}
    </button>;
}